import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import './style.css';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next'; // Add this import if not already

const PaymentAdmin = () => {
    const { t } = useTranslation();
    const [orders, setOrders] = useState([]);
    const [orderStats, setOrderStats] = useState({
        total: 0,
        pending: 0,
        completed: 0,
        cancelled: 0,
        refunded: 0,
        totalRevenue: 0,
    });
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        perPage: 10, // Number of orders per page
    });
    const [isAdmin, setIsAdmin] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        checkAdminStatus();
    }, []);

    useEffect(() => {
        if (isAdmin) {
            fetchAllOrders(pagination.currentPage);
        }
    }, [pagination.currentPage, isAdmin]);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1'; // Check stored value
        setIsAdmin(isAdmin);

        if (isAdmin) {
            fetchAllOrders(pagination.currentPage);
        } else {
		return;
        }
    };

    const fetchAllOrders = async (page) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }

            const response = await axios.get(`  https://plateformewmg.cloud/api/admin/orders?page=${page}&per_page=${pagination.perPage}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                const or = response.data.data; // Assuming orders are under the `data` key
                setOrders(or);
                setPagination(prev => ({
                    ...prev,
                    totalPages: response.data.last_page, // Assuming `last_page` is part of the response
                }));
                calculateOrderStats(or);
            } else {
                return;
            }
        } catch (error) {
                return;
        }
    };

    const calculateOrderStats = (orders) => {
        const total = orders.length;
        const pending = orders.filter(order => order.status === 'en attente').length;
        const completed = orders.filter(order => order.status === 'completed').length;
        const cancelled = orders.filter(order => order.status === 'cancelled').length;
        const refunded = orders.filter(order => order.status === 'refunded').length;
        const totalRevenue = orders.reduce((sum, order) => sum + parseFloat(order.payment.Amount), 0);

        setOrderStats({
            total,
            pending,
            completed,
            cancelled,
            refunded,
            totalRevenue,
        });
    };

    const handlePaymentStatus = async (orderId, status) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }

            const response = await axios.put(`  https://plateformewmg.cloud/api/admin/orders/${orderId}/payment-status`,
                { PaymentStatus: status },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    }
                }
            );

            if (response.status === 200) {
                // Fetch orders again to reflect changes
                fetchAllOrders(pagination.currentPage);
            } else {
return;
            }
        } catch (error) {
return;
        }
    };

    const handleView = (orderID) => {
        const order = orders.find(order => order.OrderID === orderID);
        if (order && order.status === "livré") {
            handlePaymentStatus(order.OrderID, 'payé'); // Update payment status to "payé"
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Attention!',
                text: "Vous ne pouvez pas marquer cette commande comme payée tant qu'elle n'est pas livrée.",
              });
                    }
    };

    const handleDelete = (orderID) => {
        const order = orders.find(order => order.OrderID === orderID);
        if (order && order.status === "livré") {
            handlePaymentStatus(order.OrderID, 'annulé'); // Update payment status to "annulé"
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Attention!',
                text: "Vous ne pouvez pas marquer cette commande comme payée tant qu'elle n'est pas livrée.",
              });
        }
    };

    const handlePagination = (page) => {
        setPagination(prev => ({
            ...prev,
            currentPage: page,
        }));
    };

    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                        <h1 className="text-dark display-4"> {t('Tableau_de_bord_paiements')}</h1>
                    </div>
                    <hr className="my-4" />

                    {/* Orders Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th> {t('ID_de_commande')}</th>
                                    <th> {t('Fournisseur')}</th>
                                    <th> {t('Paiement')}</th>
                                    <th> {t('Produits')}</th>
                                    <th> {t('Montant')}</th>
                                    <th> {t('statut')}</th>
                                    <th> {t('Cree_le')} </th>
                                    <th> {t('Mis_a_jour_le')}</th>
                                    <th> {t('Actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
  {orders.map((order) => (
    <tr key={order.OrderID}>
      <td>{order.idsOrder}</td>
      <td>
<strong>{order.supplier?.name || 'Commandes passe sans code promo'}</strong><br />

Phone: {order.supplier?.phone || 'Commandes passe sans code promo'}<br />
Custom ID: {order.supplier?.custom_id || 'N/A'}<br />
      </td>
      <td>
        Statut du paiement: {order.payment.PaymentStatus}<br />
        Montant du paiement {order.payment.Amount}<br />
        Date de paiement: {new Date(order.payment.PaymentDate).toLocaleString()}
      </td>
      <td>
        {order.order_items.map((item) => (
          <div key={item.OrderItemID}>
            <strong>
      {item.product.Name?.[i18n.language] || ''}
                </strong><br />
          </div>
        ))}
      </td>
      <td>
        <strong>{order.payment.Amount} {t("currency")}</strong>
      </td>
      <td>{order.status}</td>
      <td>{new Date(order.created_at).toLocaleString()}</td>
      <td>{new Date(order.updated_at).toLocaleString()}</td>

      {/* Action Buttons */}
      <td>
        <button
          className="btn btn-info"
          onClick={() => handleView(order.OrderID)}
          disabled={order.payment.PaymentStatus === 'payé' || order.status !== 'livré'} // Disable if payment status is "payé" or order status is not "livré"
          title={order.status !== 'livré' ? "Cette commande n'est pas encore livrée." : ""}
        >
           {t('Paye')}
        </button>
        {/* <button
          className="btn btn-danger"
          onClick={() => handleDelete(order.OrderID)}
          disabled={order.payment.PaymentStatus === 'annulé'} // Disable if payment status is "annulé"
        >
           {t('Annule')}
        </button> */}
      </td>
    </tr>
  ))}
</tbody>


                        </table>
                    </div>

                    {/* Pagination Controls */}
                   <div className="d-flex justify-content-center">
                        <nav>
                            <ul className="pagination">
                                <li className="page-item" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                                    <button className="page-link">           {t('Previous')}</button>
                                </li>
                                {[...Array(totalPages)].map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className="page-item" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                                    <button className="page-link">           {t('Next')}</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default PaymentAdmin;
